import React from "react";

import { Search } from './Search/Search';

export const Filter = () => {
  return (
    <Search />
  )
};
